import { render, staticRenderFns } from "./SoftwareProblems.vue?vue&type=template&id=3707cc53&"
import script from "./SoftwareProblems.vue?vue&type=script&lang=js&"
export * from "./SoftwareProblems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports